import React, { useEffect } from 'react';
import { MiniKitProvider, useMiniKit } from '@coinbase/onchainkit/minikit';
import { base } from 'wagmi/chains';
import { UserInfo, VersionInfo, DebugUtils, TBAAdapter } from './components';
import { APP_NAME, APP_TAGLINE } from './constants';
import './App.css';

const MiniApp = () => {
  const { setFrameReady, isFrameReady, context } = useMiniKit();

  useEffect(() => {
    if (!isFrameReady) {
      setFrameReady();
    }
  }, [isFrameReady, setFrameReady]);

  return (
    <div className="App">
      <DebugUtils />
      <TBAAdapter context={context}>
        <header className="App-header">
          <div className="placeholder-content">
            <div className="blue-square pie-design">
              <div className="pie-base">🟦</div>
              <div className="pie-topping">🥧</div>
            </div>
            <h1>{APP_NAME}</h1>
            <p>{APP_TAGLINE}</p>
            <UserInfo user={context?.user} />
            <VersionInfo context={context} isFrameReady={isFrameReady} />
          </div>
        </header>
      </TBAAdapter>
    </div>
  );
};

const App = () => (
  <MiniKitProvider
    chain={base}
    apiKey={process.env.REACT_APP_ONCHAINKIT_API_KEY}
    notificationProxyUrl="/api/notification"
  >
    <MiniApp />
  </MiniKitProvider>
);

export default App;
